import { Component, OnInit, Inject, ViewChild } from '@angular/core';

// entidades 
import { Puc, Query } from 'app/finanzas/entidades';


// servicios
import { FinanzasService } from 'app/finanzas/finanzas.service'; 


// angular material 
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';

// others
import Swal from 'sweetalert2';
import { AggPucComponent } from '../agg-puc/agg-puc.component';

@Component({
  selector: 'app-puc',
  templateUrl: './puc.component.html',
  styleUrls: ['./puc.component.css']
})
export class PucComponent implements OnInit {

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  listPuc = this.datos.puc;
  dataSource = new MatTableDataSource<Puc>(this.listPuc);

  cuenta: Puc = new Puc()

  constructor( public servicios: FinanzasService, public dialog: MatDialog, public dialogRef: MatDialogRef<PucComponent>, @Inject(MAT_DIALOG_DATA) private datos) { }

  // labels de la tabla
  displayedColumns: string[] = ['codigo', 'cuenta'];


  ngOnInit() {
    this.dataSource.paginator = this.paginator;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  
  definirEmpresa() {
    if (this.datos.empresa != undefined) {
      const empresaTemp = this.datos.empresa; return empresaTemp;
    }
    else {
      const empresaTemp = this.datos.idEmpresa; return empresaTemp;
    }
  }


  agregarPuc(id): void {
    const dialogRef = this.dialog.open(AggPucComponent, {
      width: '500px',
      data :{
        id,
        empresa : this.datos.empresa,
        idEmpresa : this.datos.idEmpresa,
        puc: this.datos.puc,
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      
      this.cuenta = result;

      this.guardarCuenta()   
    });
  }

  guardarCuenta(){
    if (this.cuenta['id'] != undefined){
      this.servicios.editarPuc(this.cuenta, this.cuenta['id']  )
          .subscribe(  ( status:Query) => {
          const affectedRows = status.affectedRows
          if( affectedRows != 0){
            Swal.fire({
              type: 'success',
              title: 'El registro fue actualizado'
            })
            this.servicios.getPuc(this.definirEmpresa())
              .subscribe((resp: any) => {
                
                this.dataSource = new MatTableDataSource<any>(resp);
                this.dataSource.paginator = this.paginator;
              }); 
          }
          else{ 
            Swal.fire({
              type: 'error',
              title: 'El registro no se pudo guardar',
            })
          }
          
    })
  }
    else{  
      this.servicios.addCuenta(this.cuenta)
        .subscribe(  (status : Query)  =>  {
          const affectedRows = status.affectedRows
            if(affectedRows != 0){
              Swal.fire({
                type: 'success',
                title: 'La cuenta fue añadida correctamente'
            })
              this.servicios.getPuc(this.definirEmpresa())
                .subscribe((resp : Array<Puc>) => {
                  this.dataSource = new MatTableDataSource<Puc>(resp);
                  this.dataSource.paginator = this.paginator;
                  
                }); 
          }
        else{
          Swal.fire({
              type:'error', 
              title: 'La cuenta no se pudo añadir' 
          })
        }
      })
    }
  }

  eliminar(element){
    Swal.fire({
      title: '¿Esta seguro que desea eliminar este registro?',
      type: 'warning',
      showCancelButton:true,
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si'
    }).then((result) => {
      
      if (result.value) {
        
        this.cuenta = element;
        this.cuenta['estado'] = 0;

        this.servicios.borrarCuentaPuc(this.cuenta, element.id).subscribe( (resp:Query ) => {
          if( resp.affectedRows != 0){
            Swal.fire(
              'Eliminado',
              'El archivo fue eliminado correctamente',
              'success'
            )
            this.servicios.getPuc(this.definirEmpresa())
              .subscribe((resp:Array<Puc>) => {
                this.dataSource = new MatTableDataSource<Puc>(resp);
                this.dataSource.paginator = this.paginator;
              }); 
          }
          }
        )
      }
      })
  }




      
  
  


  

  

}
